import React from "react";
import { Provider, observer } from "mobx-react";
import Store from "../../stores/NewExistingOwnerStore";
import { NewExistingOwner } from "./";

interface IProps {}
interface IState {
  store: Store;
}

const store: Store = new Store();

class App extends React.Component<IProps, IState> {
  render() {
    const { activePage } = store;

    return (
      <Provider store={store}>
        <NewExistingOwner />
      </Provider>
    );
  }
}

export default App;
